import { Workbox } from "workbox-window";

let wb = null;

if ("serviceWorker" in navigator) {
  console.log("Service worker is supported , registering events ...");
  wb = new Workbox(`${import.meta.env.BASE_URL}service-worker.js`);

  wb.addEventListener("controlling", () => {
    console.log("A new service worker is controlling the page ---> Reloading.");
    window.location.reload();
  });
  // Log various service worker lifecycle events
  wb.addEventListener("waiting", (event) => {
    console.log(
      "A new service worker has installed, but it can't activate until all tabs running the current version are closed.",
      event,
    );
  });

  wb.addEventListener("installed", (event) => {
    console.log("Service worker installed successfully", event);
  });

  wb.addEventListener("activated", (event) => {
    console.log("Service worker activated successfully", event);
  });

  wb.addEventListener("redundant", (event) => {
    console.log("Service worker became redundant", event);
  });
  // Log errors
  wb.addEventListener("error", (event) => {
    console.error("Service worker error:", event);
  });

  wb.register();
  console.log("Service worker registered successfully");
}

const workboxInstance = wb;
export default workboxInstance;
